export default __webpack_public_path__ + "static/media/attributes.4475a6f8.png";